import React from "react";
import { Col, Row } from "react-bootstrap";

export const DetailField = ({ label, value }) => {
  const displayValue =
    value && typeof value === "object" ? value.label || value.value : value;

  return (
    <div className="mb-0">
      <label className="d-block text-muted mb-1" style={{ fontSize: "12px" }}>
        {label}
      </label>
      <div className="text-black fs-13" style={{ wordBreak: "break-word" }}>
        {displayValue || "-"}
      </div>
    </div>
  );
};

export const SectionContainer = ({ title, children }) => (
  <div className="mb-5">
    <div className="d-flex align-items-center mb-3">
      <h6 className="fw-bold mb-0 fs-16 text-black pe-3">{title}</h6>
      <div className="flex-grow-1 border-top opacity-10"></div>
    </div>
    <div className=" rounded-4 p-4 bg-white shadow-sm border border-light">
      <Row className="gy-4">{children}</Row>
    </div>
  </div>
);

export default DetailField;
